import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import Loader from 'components/Loader';
import { useState } from 'react';
import { useGetMemberTypesQuery } from 'store/api/version-api.slice';

import { styles } from '../styles/memberTypesList.styles';
import MemberTypeItem from './MemberTypeItem';

const MemberTypesList = ({ setEditableMemberType, setIsEditOpen }) => {
	const { data = {}, isLoading, isFetching } = useGetMemberTypesQuery();
	const memberTypes = data.results || [];

	const [showOverlay, setShowOverlay] = useState(false);

	return (
		<Paper sx={styles.box}>
			{isLoading && <Loader variant="ghost" />}
			<List sx={styles.memberTypesList}>
				{memberTypes.map(item => {
					return (
						<MemberTypeItem
							key={item.id}
							item={item}
							setEditableMemberType={setEditableMemberType}
							setIsEditOpen={setIsEditOpen}
							setShowOverlay={setShowOverlay}
						/>
					);
				})}
			</List>
			{(showOverlay || isFetching) && <Box sx={styles.overlay}></Box>}
		</Paper>
	);
};

export default MemberTypesList;
